import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { Meeting } from '@app/application/client_meetings/types'

export const useMeetingDetailsStore = defineStore('meetingDetails', () => {
  const isEditing = ref<Record<number, boolean>>({})
  const isSaving = ref<Record<number, boolean>>({})
  const summary = ref<Record<number, string>>({})
  const completedDate = ref<Record<number, string>>({})
  const title = ref<Record<number, string>>({})

  function edit(meeting: Meeting): void {
    isEditing.value[meeting.id] = true
    isSaving.value[meeting.id] = false
    summary.value[meeting.id] = meeting?.summary || ''
    completedDate.value[meeting.id] = meeting?.completedAt || ''
    title.value[meeting.id] = meeting?.title || ''
  }

  function reset(meeting: Meeting): void {
    summary.value[meeting.id] = meeting?.summary || ''
    isEditing.value[meeting.id] = false
  }

  function setIsSaving(meeting: Meeting): void {
    isSaving.value[meeting.id] = true
  }

  function setIsSaved(meeting: Meeting): void {
    isEditing.value[meeting.id] = false
    isSaving.value[meeting.id] = false
  }

  return {
    isEditing,
    isSaving,
    summary,
    completedDate,
    title,
    edit,
    reset,
    setIsSaving,
    setIsSaved,
  }
})
